import apiInterviewVersions from '../services/api/interviewVersion'
import { getRawJWTFromToken } from './tokenUtils'

async function voiceOver(questionId, text) {
  try {
    const interviewToken = window.location.pathname.split('/')[2]

    if (!interviewToken) {
      throw new Error('Interview token not found')
    }

    const rawJWT = getRawJWTFromToken(interviewToken)

    const response = await apiInterviewVersions.generateVoiceOver(rawJWT, {
      text,
      questionId,
    })

    if (!response.success) {
      throw new Error(response.error || 'Voice over generation failed')
    }

    const audioData = atob(response.audio)
    const audioArray = new Uint8Array(audioData.length)
    for (let i = 0; i < audioData.length; i++) {
      audioArray[i] = audioData.charCodeAt(i)
    }

    const audioBlob = new Blob([audioArray], { type: 'audio/wav' })
    const audioUrl = URL.createObjectURL(audioBlob)
    const audio = new Audio(audioUrl)

    await new Promise((resolve, reject) => {
      audio.onended = resolve
      audio.onerror = reject
      audio.play().catch(reject)
    })

    URL.revokeObjectURL(audioUrl)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Voice over error:', error)
    throw error
  }
}

export { voiceOver }
